import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ContractTypeGroupService, VendorTypeService } from '@controlling/proxy/controlling/controllers';
import { MeasurementTypeService } from '@woodsupply/proxy/wood-supply/controllers/measurement-type.service';

import { ContractTypeActivity } from '../contract-type-activity/contract-type-activity';
import { ContractTypeForecast } from '../contract-type-forecast/contract-type-forecast';
import { ContractTypeMgsParameter } from '../contract-type-mgs-parameter/contract-type-mgs-parameter';
import { ContractTypePerPropertyType } from '../contract-type-per-property-type/contract-type-per-property-type';
import { ContractTypeSapParameter } from '../contract-type-sap-parameter/contract-type-sap-parameter';
import { ContractTypeTax } from '../contract-type-tax/contract-type-tax';
import { SapFicoParameter } from '../sap-fico-parameter/sap-fico-parameter';
import { SapFiParameter } from '../sap-fi-parameter/sap-fi-parameter';
import { SapServiceEntrySheetParameter } from '../sap-service-entry-sheet-parameter/sap-service-entry-sheet-parameter';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('vendorTypeId', 'Entity.VendorType', VendorTypeService)
    .displayFromNested('vendorType.name')
    .sortBy('vendorType.name')
    .build(),
  FieldBuilder
    .checkbox('useDepletionMaster', 'Entity.ContractType.UseDepletionMaster')
    .build(),
  FieldBuilder
    .text('name', 'Entity.ContractType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('measurementTypeId', 'Entity.ContractType.MeasurementType', MeasurementTypeService)
    .displayFromNested('measurementType.name')
    .sortBy('measurementType.name')
    .build(),
  FieldBuilder
    .checkbox('isThirdPartyExporter', 'Entity.ContractType.IsThirdPartyExporter')
    .build(),
  FieldBuilder
    .checkbox('isEligibleForElectronicInvoice', 'Entity.ContractType.IsEligibleForElectronicInvoice')
    .build(),
  FieldBuilder
    .text('code', 'Entity.ContractType.Code')
    .required()
    .minLength(2)
    .maxLength(6)
    .build(),
  FieldBuilder
    .checkbox('applyDepletion2', 'Entity.ContractType.ApplyDepletion2')
    .build(),
  FieldBuilder
    .foreignKey('contractTypeGroupId', 'Entity.ContractTypeGroup', ContractTypeGroupService)
    .required()
    .displayFromNested('contractTypeGroup.name')
    .sortBy('contractTypeGroup.name')
    .build(),
];

export const CONTRACTTYPE_CONFIG = {
  entityName: 'ContractType',
  localizationKey: 'Controlling::Entity.ContractType',
  fields: CONTRACTTYPE_FIELDS,
  permission: 'ControllingContract.ContractTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'ContractTypeActivity',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypeActivity',
      component: ContractTypeActivity,
    },
    {
      entityName: 'ContractTypeForecast',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypeForecast',
      component: ContractTypeForecast,
    },
    {
      entityName: 'ContractTypeMgsParameter',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypeMgsParameter',
      component: ContractTypeMgsParameter,
    },
    {
      entityName: 'ContractTypePerPropertyType',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypePerPropertyType',
      component: ContractTypePerPropertyType,
    },
    {
      entityName: 'ContractTypeSapParameter',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypeSapParameter',
      component: ContractTypeSapParameter,
    },
    {
      entityName: 'ContractTypeTax',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.ContractTypeTax',
      component: ContractTypeTax,
    },
    {
      entityName: 'SapFicoParameter',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.SapFicoParameter',
      component: SapFicoParameter,
    },
    {
      entityName: 'SapFiParameter',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.SapFiParameter',
      component: SapFiParameter,
    },
    {
      entityName: 'SapServiceEntrySheetParameter',
      foreignKeyField: 'contractTypeId',
      localizationKey: 'Controlling::Entity.SapServiceEntrySheetParameter',
      component: SapServiceEntrySheetParameter,
    },
  ],
};
